//отдельная точка входа для расписания
//корневой роут в любом случае конфликтовать будет, может и остальные, конфликты никак не разрешить
//только отдельной точкой входа
import { createApp } from "vue";
import App from "moodleDir/blocks/manage_groups/timetable/components/App.vue";

import { createWebHashHistory, createRouter } from "vue-router";
import axios, { AxiosError } from "axios";
// -----------Vuetify---------------
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { ru } from "vuetify/locale";
import colors from "vuetify/lib/util/colors.mjs";
import * as vuetify_components from "vuetify/components";
import * as vuetify_directives from "vuetify/directives";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
/**
 *
 * @param {AxiosError} error
 */
let axiosDefaultErrorHandler = function (error) {
  if (error.response) {
    console.log(error.response);
  } else {
    console.log(error);
  }
};

let blockContext = {
  routers: {
    timetable: require.context(
      "moodleDir/blocks/manage_groups/timetable",
      true,
      /^(?!node_modules).*\/router.js$/i,
    ),
    //'psm_test' : require.context('moodleDir/blocks/psm_test/', true, /^(?!node_modules).*\/router.js$/i)
  },
};

//console.log(model);
let blockName = "timetable";
let routes = [];
//-----------load routes---------

let context = blockContext.routers[blockName];

context.keys().forEach((rPath) => {
  let folderParts = rPath.split("/");
  folderParts.shift(); //shift ".""
  folderParts.pop(); //pop "router.js"

  context(rPath).default.routes.forEach((route) => {
    route.path = "/" + folderParts.join("/") + route.path;
    route.name = blockName + "_" + folderParts.join("_") + "_" + route.name;

    routes.push(route);
  });
});

//console.log(routes);
//------------------------------
let router = null;
const vuetify = createVuetify({
  display: {
    mobileBreakpoint: 960,
  },
  locale: {
    messages: { ru },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: colors.blue.darken2,
        },
      },
      dark: {
        colors: {
          primary: colors.blue.darken2,
        },
      },
    },
  },
  components: {
    vuetify_components,
    //VDataTable,
  },
  vuetify_directives,
  icons: {
    defaultSet: "mdi",
  },
});

if (document.getElementById("procollege_timetable") != null) {
  router = createRouter({
    history: createWebHashHistory(),
    routes,
  });
}
//--------------------------------------------------
//----------------------------
if (document.getElementById("procollege_timetable") != null) {
  const app = createApp({
    extends: App,
  });
  app.config.globalProperties.axios = axios;
  app.config.globalProperties.axiosDefaultErrorHandler =
    axiosDefaultErrorHandler;

  app.config.globalProperties.$model = model;
  app.use(vuetify).use(router).mount("#procollege_timetable");
}
